import { useRuntimeConfig } from '#imports'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export function useExperienceLayerIsEnabled() {
  const { market } = useMarketplace()
  const { FF_CMS_ENABLE_EXPERIENCE_LAYER_COUNTRIES } = useRuntimeConfig().public

  return FF_CMS_ENABLE_EXPERIENCE_LAYER_COUNTRIES?.includes(market.countryCode)
}
